import axios from "axios";
import {API_BASE_URL} from "../../services/config";
import {IServiceData} from "./i-service";

// Get defualt user services
export const getDefaultUserServiceService = async (token: string) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.get(API_BASE_URL + "services", config);

  return response.data;
};

// Update user service
export const updateUserServiceService = async (
  serviceData: IServiceData,
  token: string
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const payloadContainsNull = Object.values(serviceData).includes(null);

  const requestUrl = `${API_BASE_URL}services/${payloadContainsNull ? "1" : "0"}`;
  // console.log({requestUrl, payloadContainsNull, serviceData});
  const response = await axios.post(requestUrl, serviceData, config);

  return response.data;
};
